import { getAxiosClient } from "../../axios-client";
import { UserChangePasswordByOperatorBody, UserChangePasswordByOperatorResponse } from "./types";

const axiosClient = getAxiosClient();
export const userChangePasswordByOperator = async (body: UserChangePasswordByOperatorBody) => {
  return await axiosClient.ax.post<UserChangePasswordByOperatorResponse>(
    "/Account/ResetPasswordByOperator",
    body
  );
};
